import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Tabs, Tab } from '@mui/material';
import OfferKPIComponent from './OfferKPIComponent';
import OfferSummaryComponent from './OfferSummaryComponent';
import DocumentTasksContainer from './DocumentTasksContainer';
import Timeline from '@mui/icons-material/Timeline';
import Assignment from '@mui/icons-material/Assignment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { loadDocumentTasks } from 'features/tasks/actionCreators';
import { loadOfferSummary, loadOfferKpi } from '../../actionCreators';

export const OfferWizardSidebarSummaryContainer = ({
  t,
  documentId,
  siteId,
  offerSummary,
  offerSummaryIsLoaded,
  offerKpi,
  documentTasks,
  actions,
  rights
}) => {
  const [tabValue, setTabValue] = useState(0);
  let firstUpdate = false;

  useEffect(() => {
    if (Number.isInteger(documentId)) {
      actions.loadOfferSummary(documentId, siteId);
      actions.loadDocumentTasks(documentId, siteId);
      actions.loadOfferKpi(documentId, siteId);
    }
    firstUpdate = true; // eslint-disable-line react-hooks/exhaustive-deps
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!firstUpdate) {
      if (Number.isInteger(documentId)) {
        actions.loadOfferSummary(documentId, siteId);
        actions.loadOfferKpi(documentId, siteId);
      }
    }
  }, [documentId, siteId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!firstUpdate && !offerSummaryIsLoaded && Number.isInteger(documentId)) {
      actions.loadOfferSummary(documentId, siteId);
    }
  }, [offerSummaryIsLoaded]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!firstUpdate) {
      if (Number.isInteger(documentId)) {
        actions.loadOfferKpi(documentId, siteId);
      }
    }
  }, [offerKpi]); // eslint-disable-line react-hooks/exhaustive-deps

  const tasksTab = <DocumentTasksContainer documentTasks={documentTasks} documentId={documentId} siteId={siteId} rights={rights} />;

  const summaryTab = (
    <>
      <OfferSummaryComponent isIconCard={false} offerSummary={offerSummary} />
      <OfferKPIComponent isIconCard={false} offerKpi={offerKpi} />
    </>
  );

  const handleChange = (_, value) => {
    setTabValue(value);
  };

  return (
    <>
      <Tabs value={tabValue} onChange={handleChange} variant='fullWidth' indicatorColor='secondary' textColor='secondary'>
        <Tab icon={<Timeline />} label={t('Offer.SummaryTabTitle')} />
        {documentTasks && documentTasks.length > 0 && <Tab icon={<Assignment />} label={t('Tasks.TabTitle')} />}
      </Tabs>
      {tabValue === 0 && summaryTab}
      {tabValue === 1 && tasksTab}
    </>
  );
};

OfferWizardSidebarSummaryContainer.propTypes = {
  t: PropTypes.func.isRequired,
  documentId: PropTypes.number,
  siteId: PropTypes.number,
  offerSummary: PropTypes.object.isRequired,
  offerKpi: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  offerSummaryIsLoaded: PropTypes.bool,
  rights: PropTypes.object,
  documentTasks: PropTypes.array
};

function mapStateToProps(state, route) {
  const key = `${route.documentId}-${route.siteId}`;
  return {
    offerSummary: state.currentOffer.offerSidebarData.offerSummary,
    offerSummaryIsLoaded: state.currentOffer.offerSidebarData.offerSummaryIsLoaded,
    offerKpi: state.currentOffer.offerSidebarData.offerKpi,
    documentTasks: state.tasksData[key]?.tasksList
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ loadOfferSummary, loadOfferKpi, loadDocumentTasks }, dispatch),
    dispatch
  };
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withTranslation())(OfferWizardSidebarSummaryContainer);
